// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__KrKWT","footer":"Form_footer__1dXpg"};